import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var HeaderService = /** @class */ (function () {
    function HeaderService() {
        /**
         * Instancia de subject como Subject<any>, observable de actualización de cambios
         *
         * *subject instance as Subject any>, updated changes observable*
         *
         * @access private
         * @type {Subject<any>} subject
         */
        this.subject = new Subject();
        /**
         * Declaración de headerState como suscriptor, escucha cambios
         *
         * *HeaderState declaration as Observable, listener of changes*
         *
         * @access private
         * @type {string} DEFAULT_URL_PATH
         */
        this.headerState = this.subject.asObservable();
    }
    /**
     * Función para mostrar el header en las pantallas
     *
     * *Function to show the header on screens *
     *
     * @type {function}
     * @param {boolean} steps
     * @param {boolean} showTitle
     */
    HeaderService.prototype.show = function (steps, showTitle, close) {
        var header = { show: true, steps: !!steps, showTitle: !!showTitle, close: !!close };
        this.subject.next(header);
        // this.loaderService.hide()
    };
    /**
     * Función para ocultar el header en las pantallas
     *
     * *Function to hide the header on screens *
     *
     * @type {function}
     */
    HeaderService.prototype.hide = function () {
        var header = { show: false, steps: false, showTitle: false, close: false };
        this.subject.next(header);
    };
    HeaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HeaderService_Factory() { return new HeaderService(); }, token: HeaderService, providedIn: "root" });
    return HeaderService;
}());
export { HeaderService };
